export function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}


//////////////////
// WEBPACK FOOTER
// ../~/_react-router@3.2.4@react-router/es/PromiseUtils.js
// module id = 690
// module chunks = 1